'use client';

import { useMutation } from '@apollo/client/react';

import {
  END_MOBILE_SESSION,
  LINK_MOBILE_AUDIO,
  SYNC_SESSION_TIMESTAMP,
  UtSessionSyncType,
} from '@/survey-graphql';

import { encodeMobileUtEndReason } from './shared-survey-mobile-ut.helpers';

// test-exception: Apollo mutation binding only — the lifecycle logic it feeds is covered by mobile-ut-lifecycle.helpers.spec.ts.
export function useMobileUtSessionGateway() {
  const [linkMobileAudioMutation] = useMutation(LINK_MOBILE_AUDIO);
  const [endMobileSessionMutation] = useMutation(END_MOBILE_SESSION);
  const [syncTimestampMutation] = useMutation(SYNC_SESSION_TIMESTAMP);

  return {
    syncRecordingStarted: (uniqueId: string) =>
      syncTimestampMutation({
        variables: {
          input: {
            uniqueId,
            type: UtSessionSyncType.RecordingStarted,
          },
        },
      }),
    linkAudio: ({
      insightId,
      uniqueId,
    }: {
      insightId: string;
      uniqueId: string;
    }) =>
      linkMobileAudioMutation({
        variables: { input: { insightId, uniqueId } },
      }),
    endSession: ({
      uniqueId,
      reason,
      redirectUrl,
    }: {
      uniqueId: string;
      reason: string;
      redirectUrl: string | null;
    }) =>
      endMobileSessionMutation({
        variables: {
          input: {
            uniqueId,
            reason: encodeMobileUtEndReason({ reason, redirectUrl }),
          },
        },
      }),
  };
}
